// Este arquivo deve ser importado no arquivo _app.tsx
// Ele verifica se o usuário tem trial expirado e exibe uma mensagem de acordo

import { useContext, useEffect } from "react";
import { useRouter } from "next/router";
import { AuthContext } from "../../context/AuthContext";

/**
 * Componente que verifica as condições de trial em todas as páginas
 * - Bloqueia acesso a páginas de agendamento quando o trial está expirado
 * - Exibe mensagem sobre trial expirado quando aplicável
 */
export const TrialStatusHandler: React.FC = () => {
    const { user } = useContext(AuthContext);
    const router = useRouter();

    // Rotas relacionadas a agendamento que devem ser bloqueadas para usuários com trial expirado
    const schedulingRoutes = ['/schedule', '/dash_agenda'];

    // Verificar se a rota atual é relacionada a agendamento
    const isSchedulingRoute = schedulingRoutes.includes(router.pathname);

    useEffect(() => {
        // Se o usuário está autenticado e tem trial expirado
        if (user?.trial_status === "expired") {
            // Se estiver tentando acessar uma página de agendamento, redirecionar para planos
            // mas sem mostrar toast, pois isso será feito apenas no dashboard
            if (isSchedulingRoute) {
                router.replace("/planos");
            }
            // Não mostramos mais o toast em outras páginas para evitar alertas repetitivos
        }
    }, [user, isSchedulingRoute, router]);

    // Este componente não renderiza nada visível
    return null;
};

export default TrialStatusHandler;
